
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-welfare/playground",
      function () {
        return require("private-next-pages/public-welfare/playground.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-welfare/playground"])
      });
    }
  